import React, { useEffect, useState, useContext } from 'react'
import UserTableView from '../../views/UserManagement/TableView'
import { Button } from '@mui/material'
import Layout from '../../product/components/templates/Layout'
import DynamicUser from './dynamicUser'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import ReportContext from '@/product/context/report/reportContext'
import { handleRedirectInternal } from '@/product/common/components'
import { useHistory } from 'react-router-dom'

const UserCommon = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const history = useHistory()
    const { user_tablefields } = dynamicContext
    const [mapArrayData, setMapArrayData] = useState([])
    const { getAllExportDownload } = useContext(ReportContext)

    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        user_type: 0,
    })
    const [searchInfo, setSearchInfo] = useState({})
    const [tableValue, setTableValue] = useState([])

    let action =
        props.match.params.action !== 'all' ? props.match.params.action : null

    const toggleFullScreenPopup = (popup, status, id) => {
        handleRedirectInternal(history, `user/edit/${id}`)
    }

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'edit') {
            handleRedirectInternal(history, `user/edit/${id}`)
        }
    }

    const custom = {
        action: {
            value: action,
            type: 'in',
            field: 'u.status',
        },
        // admin: {
        //     value: '0',
        //     type: 'in',
        //     field: 'u.admin',
        // },///
        status: {
            value: '',
            type: 'in',
            field: 'u.status',
        },
    }

    useEffect(() => {
        if (user_tablefields && user_tablefields.length) {
            let dynamicValueAssign = {}
            let tableFields = [...user_tablefields]

            let searchData = user_tablefields.map((el) => {
                if (el.field === 'first_name') {
                    el.table_search = 1
                    el.sort_field = ''
                    el.class = 'col-3'
                    el.label = 'First Name'
                    el.filter_type = 'like'
                    el.filter = true
                    el.is_default = 1
                    el.diff_sort = 1
                } else if (el.field === 'last_name') {
                    el.table_search = 1
                    el.sort_field = ''
                    el.class = 'col-3'
                    el.label = 'Last Name'
                    el.filter_type = 'like'
                    el.filter = true
                    el.is_default = 1
                    el.diff_sort = 1
                } else if (el.field === 'username') {
                    el.class = 'col-3'
                    el.filter_type = 'like'
                } else if (el.field === 'email') {
                    el.table_search = 1
                    el.sort_field = ''
                    el.class = 'col-3'
                    el.label = 'Email'
                    el.filter_type = 'like'
                    el.filter = true
                    el.is_default = 1
                    el.diff_sort = 1
                } else if (el.field === 'id') {
                    el.table_search = 1
                    el.sort_field = ''
                    el.class = 'col-3'
                    el.label = 'User ID'
                    el.field = 'id'
                    el.name = 'id'
                    el.view_page = '3'
                    el.active = 1
                    el.type = 'text'

                    el.filter_type = 'in'
                    el.filter = true
                    el.is_default = 1
                    el.diff_sort = 1
                } else if (el.field === 'seller_status') {
                    el.field = 'status'
                    el.name = 'status'
                }

                // Return the modified element (whether modified or not)

                return el
            })
            if (props.match.params.action == 'all') {
                searchData.push({
                    label: 'Status',
                    class: 'col-md-4 col-sm-6 col-12',
                    type: 'select',
                    filter_type: 'in',
                    field: 'status',
                    name: 'status',
                    filter: true,
                    table_search: 1,
                    view_page: '3',

                    is_default: 1,
                    active: 1,

                    options: [
                        {
                            show: 'All',
                            value: '',
                        },
                        {
                            show: 'Active',
                            value: 'active',
                        },
                        {
                            show: 'UnVerified',
                            value: 'unverified',
                        },
                        {
                            show: 'Deactive',
                            value: 'deactivate',
                        },
                        {
                            show: 'Rejected',
                            value: 'rejected',
                        },

                        {
                            show: 'Waiting admin approve',
                            value: 'email_unverified',
                        },

                        {
                            show: 'Suspended',
                            value: 'deleted',
                        },
                    ],
                })
            }

            dynamicValueAssign.data = searchData
                ?.filter((item) => item?.table_search === 1)
                .map((buscat) => {
                    return Object.assign(buscat, {
                        name: buscat.field,
                    })
                })
            tableFields.map((data) => {
                if (data.field === 'email') {
                    data.click = true
                    data.onclick = onClickEdit
                    data.clickID = 'id'
                    data.secondaryClickID = 'user_id'
                    data.clickType = 'edit'
                    data.type = 'hyperlink'
                }
            })
            setSearchInfo(dynamicValueAssign)
            // Assuming tableFields is an array of objects
            const filteredTableFields = tableFields?.filter(
                (el) => el.field !== 'seller_status'
            )

            // Now, set the table value and map the filtered data
            setTableValue(filteredTableFields)
            setMapArrayData(filteredTableFields)
        }
    }, [user_tablefields, action])
    return (
        <>
            <Layout>
                <div className="dashboard listing maillisting">
                    <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4">
                        <Button
                            id="userManage_dynamic_add"
                            variant="outlined"
                            className="btnOutlined mr-2"
                            onClick={() =>
                                toggleFullScreenPopup(true, 'new', 0)
                            }
                        >
                            <span className="material-icons">
                                person_add_alt_1
                            </span>
                            Add Individual User
                        </Button>
                        <Button
                            id="userManage_dynamic_report"
                            onClick={() =>
                                getAllExportDownload({
                                    action: 'export',
                                    order: 'asc',
                                    orderby: '',
                                    search: 'all',
                                    report: `${action}_user_management`,
                                })
                            }
                        >
                            <span className="material-icons">get_app</span>
                            Export All Data
                        </Button>
                    </div>

                    <UserTableView
                        searchInfo={searchInfo}
                        customFilter={custom}
                        tableValue={tableValue}
                        mapArrayData={mapArrayData}
                        showSelectValues={true}
                        toggleFullScreenPopup={toggleFullScreenPopup}
                        tableActionString={[
                            'active',
                            'rejected',
                            'deactivate',
                            'suspended',
                            'deactivated',
                        ]}
                        listActionString={['switchuser']}
                        action={action}
                        advFilters={false}
                    />
                </div>
                {/* <DynamicUser data={manage} function={toggleFullScreenPopup} /> */}
            </Layout>
        </>
    )
}

export default UserCommon
